import { createAsyncThunk } from '@reduxjs/toolkit';
import { thunkAxiosRequest } from 'shared/api';
import {
	Timeslot,
	TimeslotsParams,
	TimeslotsBookingParams,
	BookingSlot,
} from './types';

export const getTimeslots = createAsyncThunk<Timeslot[], TimeslotsParams>(
	'getTimeslots',
	async (params: TimeslotsParams, { rejectWithValue }) => {
		return thunkAxiosRequest({
			path: '/api/v1/slots',
			params,
			rejectWithValue,
		});
	},
);

export const getBookingTimeslots = createAsyncThunk<
	BookingSlot[],
	TimeslotsBookingParams
>(
	'getBookingTimeslots',
	async (params: TimeslotsBookingParams, { rejectWithValue }) => {
		return thunkAxiosRequest({
			method: 'post',
			path: '/api/v1/slots',
			params,
			rejectWithValue,
		});
	},
);

export const getAllBookingTimeslots = createAsyncThunk<
	BookingSlot[],
	TimeslotsBookingParams
>(
	'getAllBookingTimeslots',
	async (params: TimeslotsBookingParams, { rejectWithValue }) => {
		return thunkAxiosRequest({
			method: 'post',
			path: '/api/v1/slots',
			params,
			rejectWithValue,
		});
	},
);
